import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { FiUsers, FiBarChart2, FiAlertCircle } from 'react-icons/fi';
import ErrorBoundary from '../components/ErrorBoundary';
import SimonReceivableAnalytics from '../components/SimonReceivableAnalytics';

const SimonDashboardContent = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    return (
        <div className="space-y-6 w-full max-w-none px-8">
            <div className="bg-white rounded-lg shadow p-6">
                <h2 className="text-xl font-semibold mb-6">Simon Dashboard Overview</h2>

                {error && (
                    <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-md flex items-center">
                        <FiAlertCircle className="mr-2" />
                        {error}
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* Total Customer Card */}
                    <div className="bg-blue-50 p-4 rounded-lg">
                        <div className="flex items-center">
                            <FiUsers className="h-8 w-8 text-blue-600" />
                            <div className="ml-4">
                                <h3 className="text-lg font-medium text-blue-800">Total Customer</h3>
                            </div>
                        </div>
                        <div className="mt-4">
                            <p className="text-sm text-blue-700">pending</p>
                        </div>
                    </div>

                    {/* Last Month Analytics Card */}
                    <div className="bg-purple-50 p-4 rounded-lg">
                        <div className="flex items-center">
                            <FiBarChart2 className="h-8 w-8 text-purple-600" />
                            <div className="ml-4">
                                <h3 className="text-lg font-medium text-purple-800">Last Month Analytics</h3>
                            </div>
                        </div>
                        <div className="mt-4">
                            <p className="text-sm text-purple-700">pending</p>
                        </div>
                    </div>

                    {/* This Month Analytics Card */}
                    <div className="bg-yellow-50 p-4 rounded-lg">
                        <div className="flex items-center">
                            <FiBarChart2 className="h-8 w-8 text-yellow-600" />
                            <div className="ml-4">
                                <h3 className="text-lg font-medium text-yellow-800">This Month Analytics</h3>
                            </div>
                        </div>
                        <div className="mt-4">
                            <p className="text-sm text-yellow-700">pending</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Simon Receivable Analytics Section */}
            <SimonReceivableAnalytics />
        </div>
    );
};

const SimonDashboard = () => {
    return (
        <Layout>
            <ErrorBoundary
                fallbackTitle="Simon Dashboard Error"
                fallbackDescription="An error occurred while loading the Simon dashboard. Please try again or contact support if the problem persists."
            >
                <SimonDashboardContent />
            </ErrorBoundary>
        </Layout>
    );
};

export default SimonDashboard;
